import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  meta: {
    title: '违规原因',
    auth: true,
    authorityValue: "store-offshelf-manage"
  },
  name: 'violation',
  data: function data() {
    return {
      cardData: [],
      goodsId: ''
    };
  },
  methods: {
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.violationReason(item);

              case 2:
                data = _context.sent;
                _this.cardData = data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    var query = this.$route.query;
    this.goodsId = this.$route.query.goodsId;
    this.dataBind(query);
  }
};